const resourceData = [
	{
		image: 'case-study-justworks.jpg',
		title: 'Case Study: Justworks',
		tag: 'Case Study',
		description: 'See how combining full-funnel marketing solutions can increase opportunities.',
		link: 'https://www.business.com/images/pages/marketing-resources/Justworks-Case-Study.pdf',
		attribution: 'SARINYAPINNGAM / Getty Images',
		isNew: true,
	},
	{
		image: 'best-practices-for-working-leads.jpg',
		title: 'Best Practices for Working Leads',
		tag: 'Whitepaper',
		description: 'Learn how you can turn leads into reliable customers.',
		link: 'https://www.business.com/images/pages/marketing-resources/Best-Practices-for-Working-Leads.pdf',
		attribution: 'Giuseppe Miglino / Getty Images',
		isNew: false,
	},
	{
		image: 'how-to-turn-prospects-into-brand-champions-online.jpg',
		title: 'How to Turn Prospects into Brand Champions - Online',
		tag: 'Whitepaper',
		description: 'Master engagement in the digital marketplace.',
		link:
			'https://www.business.com/images/pages/marketing-resources/How-to-turn-prospects-into-brand-champions-online.pdf',
		attribution: 'metamorworks. / Getty Images',
		isNew: false,
	},
	{
		image: 'case-study-eztexting.jpg',
		title: 'Case Study: EZ Texting',
		tag: 'Case Study',
		description: 'Learn how Qualified Traffic can provide intent website traffic and expand brand presence.',
		link: 'https://www.business.com/images/pages/marketing-resources/EZTexting-Case-Study.pdf',
		attribution: 'metamorworks / Getty Images',
		isNew: true,
	},
	{
		image: 'marketing-during-a-pandemic.jpg',
		title: 'Marketing During a Pandemic',
		tag: 'Survey',
		description: 'Learn tactics to market in spite of a pandemic.',
		link: 'https://www.business.com/images/pages/marketing-resources/Marketing-during-a-pandemic.pdf',
		attribution: '899429 / Getty Images',
		isNew: false,
	},
	{
		image: 'the-basics-of-seo.jpg',
		title: 'The Basics of SEO',
		tag: 'Video',
		description: 'Learn how basic SEO tips and how to navigate Google Updates.',
		link: 'https://vimeo.com/433733327',
		attribution: 'Blue Planet Studio / Getty Images',
		isNew: false,
	},
	{
		image: 'case-study-1888goanswer.jpg',
		title: 'Case Study: 1-888-GO-ANSWER',
		tag: 'Case Study',
		description: "Demonstrated success of business.com's full funnel marketing solutions.",
		link: 'https://www.business.com/images/pages/marketing-resources/1888GoAnswerCaseStudy.pdf',
		attribution: 'Kritchanut / Getty Images',
		isNew: false,
	},
	{
		image: 'customer-testimonials.jpg',
		title: 'Customer Testimonials',
		tag: 'PDF',
		description: 'Hear what our customers are saying.',
		link: 'https://www.business.com/images/pages/marketing-resources/Testimonials-One-Sheeter.pdf',
		attribution: 'HAKINMHAN / Getty Images',
		isNew: false,
	},
	{
		image: 'top-trends-that-will-transform-your-marketing-strategy.jpg',
		title: 'Top Trends That Will Transform Your Marketing Strategy',
		tag: 'Whitepaper',
		description: 'Use data-driven marketing to boost outcomes for your business.',
		link: 'https://www.business.com/images/pages/marketing-resources/Top-Trends-Transform-Marketing.pdf',
		attribution: 'Urupong / Getty Images',
		isNew: false,
	},
	{
		image: 'tips-for-communicating-with-customers.jpg',
		title: 'Tips for Communicating with Customers',
		tag: 'Video',
		description: 'Learn to create effective customer communications.',
		link: 'https://vimeo.com/426832683',
		attribution: 'scyther5 / Getty Images',
		isNew: false,
	},
	{
		image: 'tips-for-supporting-sales.jpg',
		title: 'Tips for Supporting Sales',
		tag: 'Video',
		description: 'Sales enablement tips for a changing marketplace.',
		link: 'https://vimeo.com/430511979',
		attribution: 'AntonioGuillem / Getty Images',
		isNew: false,
	},
	{
		image: 'what-to-do-with-top-funnel-leads.jpg',
		title: 'What to Do with Top Funnel Leads',
		tag: 'Video',
		description: 'Methods for effectively nurturing leads through the sales funnel.',
		link: 'https://vimeo.com/428567560',
		attribution: 'IvelinRadkov / Getty Images',
		isNew: false,
	},
]

export default resourceData
